export default __webpack_public_path__ + "static/media/buttons-card-4-active.cc22c99d.svg";